import l from "./util/net.js";
import De from "./models/braze-event.js";
import v from "./common/event-logger.js";
import { randomInclusive as a } from "./util/math.js";
import H from "./models/request-result.js";
import {
  logger as E,
  IndexedDBAdapter as et,
  Guid as P,
  EventTypes as f,
} from "../shared-lib/index.js";
import { STORAGE_KEYS as s } from "./managers/storage-manager.js";
import m from "./managers/subscription-manager.js";
import vt from "./Push/utils/push-utils.js";
import h from "./util/request-header-utils.js";
import { removeAllVisibleInAppMessages as di } from "./InAppMessage/ui/remove-all-visible-in-app-messages.js";
export default class Wt {
  constructor(t, i, s, e, h, n, o, r, l, u) {
    (this.tu = t),
      (this.baseUrl = i),
      (this.C = s),
      (this.eu = e),
      (this.vs = h),
      (this.h = n),
      (this.B = o),
      (this.$c = r),
      (this.hl = l),
      (this.j = u),
      (this.tu = t),
      (this.baseUrl = i),
      (this.Zc = 0),
      (this.bE = o.dE() || 0),
      (this.sd = null),
      (this.C = s),
      (this.eu = e),
      (this.vs = h),
      (this.h = n),
      (this.B = o),
      (this.hl = l),
      (this.j = u),
      (this.$c = r),
      (this.hd = new m()),
      (this.nd = null),
      (this.rd = 50),
      (this.ld = !1),
      (this.ud = !1);
  }
  ad(t, i) {
    return !t && !i && this.hl.Jh() >= this.rd;
  }
  md(t) {
    let i = this.C.am();
    if (t.length > 0) {
      const s = this.vs.getUserId();
      for (const e of t) {
        const t = (!e.userId && !s) || e.userId === s;
        e.type === f.Sm && t && (i = !0);
      }
    }
    return i;
  }
  fd(t = !1, i = !0, e, n, o, r = !1, u = !1) {
    i && this.gd();
    const c = this.B.RE(),
      d = this.B.IE();
    let m = !1;
    const f = (t, r, u = -1) => {
        const c = new Date().valueOf();
        h.K(this.B, h.H.Ze, c),
          -1 !== u && r.push(["X-Braze-Req-Tokens-Remaining", u.toString()]);
        let d = !1;
        l.O({
          url: this.baseUrl + "/data/",
          data: t,
          headers: r,
          W: (i) => {
            null != t.respond_with &&
              t.respond_with.triggers &&
              (this.Zc = Math.max(this.Zc - 1, 0)),
              this.j.Y(t, i, r)
                ? (this.hl.Z(),
                  this.h.Sc(i),
                  (null != t.respond_with &&
                    t.respond_with.user_id != this.vs.getUserId()) ||
                    (null != t.device && this.B.bt(s.ft.ac, t.device),
                    null != t.sdk_metadata &&
                      (this.B.bt(s.ft.Dl, t.sdk_metadata),
                      this.B.bt(s.ft.Tl, this.C.yt())),
                    this.$c(i),
                    h.xl(this.B, h.H.Ze, 1),
                    "function" == typeof e && e()))
                : i.auth_error && (d = !0);
          },
          error: () => {
            (d = !0),
              null != t.respond_with &&
                t.respond_with.triggers &&
                (this.Zc = Math.max(this.Zc - 1, 0)),
              this.j.kl(t.events, t.attributes),
              "function" == typeof n && n();
          },
          tt: (t, s) => {
            "function" == typeof o && o(!d);
            const e = this.j.Vl(s);
            let n = 0;
            if (e)
              switch (e.type) {
                case "date":
                  n = Math.max(e.value - new Date().valueOf(), 0);
                  break;
                case "timestamp":
                  n = e.value;
              }
            if (i && !m) {
              if (d) {
                h.Zl(this.B, h.H.Ze);
                const t = this.h.st(),
                  i = this.h.it(),
                  s = this.h.nt();
                let e = this.sd;
                (null == e || e < t) && (e = t);
                const o = Math.min(s, a(t, e * i)) + n;
                this.pd(o);
              } else this.pd(Math.max(1e3 * this.bE, n));
              m = !0;
            }
          },
        });
      },
      g = this.md(c),
      p = t || g;
    if (this.ad(r, g))
      return void E.info(
        "Declining to flush data due to 50 consecutive authentication failures",
      );
    if (i && !this.j.Ml(c, d, p))
      return this.pd(), void ("function" == typeof o && o(!0));
    const v = this.j.$l(p, c, d, u);
    p && this.Zc++;
    let b = !1;
    if (v)
      for (const t of v)
        this.j.J(
          t.requestData,
          (i) => f(t.requestData, t.headers, i),
          h.H.Ze,
          n,
        ),
          (b = !0);
    this.hl.wh() && i && !b
      ? this.pd()
      : g &&
        (E.info("Invoking new session subscriptions"),
        this.hd.L(),
        (this.ud = !0));
  }
  vd() {
    return this.Zc > 0;
  }
  pd(t = 1e3 * this.bE) {
    this.ld ||
      (this.gd(),
      (this.nd = window.setTimeout(() => {
        if (document.hidden) {
          const t = "visibilitychange",
            i = () => {
              document.hidden ||
                (document.removeEventListener(t, i, !1), this.fd());
            };
          document.addEventListener(t, i, !1);
        } else this.fd();
      }, t)),
      (this.sd = t));
  }
  gd() {
    null != this.nd && (clearTimeout(this.nd), (this.nd = null));
  }
  initialize() {
    (this.ld = !1), this.pd();
  }
  destroy() {
    this.hd.removeAllSubscriptions(),
      this.hl.Gh(),
      this.gd(),
      (this.ld = !0),
      this.fd(void 0, !1, void 0, void 0, void 0, void 0, !0),
      (this.nd = null),
      (this.ud = !1);
  }
  rn(t) {
    return this.ud ? (t(), null) : this.hd.Rt(t);
  }
  openSession() {
    const t = this.C.yt() !== this.C.el();
    t && (this.B.hE(s.Ou.tl), this.B.hE(s.Ou.Cu)),
      this.fd(!1, void 0, () => {
        t && (this.B.zt(s.ft.vo), this.B.zt(s.ft.Dt));
      }),
      this.Ya(),
      t &&
        import("./Push/push-manager-factory.js").then((t) => {
          if (this.ld) return;
          const i = t.default.ra();
          if (
            null != i &&
            (vt.isPushPermissionGranted() || vt.isPushBlocked())
          ) {
            const t = () => {
                i.du()
                  ? E.info(
                      "Push token maintenance is disabled, not refreshing token for backend.",
                    )
                  : i.subscribe();
              },
              e = (i, s) => {
                s && t();
              },
              h = () => {
                const i = this.B.dt(s.ft.Uu);
                (null == i || i) && t();
              },
              n = et.Us.Rs;
            new et(n, E).kr(n.Fs.Fu, e, h);
          }
        });
  }
  bd() {
    this.B.zt(s.ft.lo), this.B.zt(s.ft.Ps), this.B.zt(s.ft.Wn);
  }
  wd() {
    var t, i;
    this.B.zt(s.ft.Jl), this.B.zt(s.ft.lE);
    const e = h.H;
    for (const i in e) {
      const s = e[i];
      this.j.lc(s, null === (t = this.h) || void 0 === t ? void 0 : t.Dc(s));
    }
    this.j.hc(null === (i = this.h) || void 0 === i ? void 0 : i.qc());
  }
  changeUser(t, i, e) {
    const h = this.vs.getUserId();
    if (h !== t) {
      this.C.jm(),
        this.bd(),
        di(),
        null != h && this.fd(void 0, !1, void 0, void 0, void 0),
        this.vs.Ju(t),
        e ? this.hl.setSdkAuthenticationSignature(e) : this.hl.yh();
      for (let t = 0; t < i.length; t++) i[t].changeUser(null == h);
      this.j.fo(),
        null != h && this.B.zt(s.ft.rE),
        this.B.zt(s.ft.ac),
        this.B.zt(s.ft.uE),
        this.wd(),
        this.openSession(),
        E.info('Changed user to "' + t + '".');
    } else {
      let i = "Doing nothing.";
      e &&
        this.hl.jh() !== e &&
        (this.hl.setSdkAuthenticationSignature(e),
        (i = "Updated SDK authentication signature")),
        E.info(`Current user is already ${t}. ${i}`);
    }
  }
  requestImmediateDataFlush(t) {
    this.gd(), this.C.el();
    this.fd(
      void 0,
      void 0,
      void 0,
      () => {
        E.error("Failed to flush data, request will be retried automatically.");
      },
      t,
      !0,
    );
  }
  yr(t, i) {
    this.C.el(),
      E.info("Requesting explicit trigger refresh."),
      this.fd(!0, void 0, t, i);
  }
  Gu(t, i) {
    const e = f.kd,
      h = { a: t, l: i },
      n = v.lt(e, h);
    return (
      n && (E.info(`Logged alias ${t} with label ${i}`), this.B.bt(s.ft.uE, h)),
      n
    );
  }
  Mu(t, i, s) {
    if (this.h.qu(i))
      return (
        E.info(`Custom Attribute "${i}" is blocklisted, ignoring.`), new H()
      );
    const e = { key: i, value: s },
      h = v.lt(t, e);
    if (h) {
      const t = "object" == typeof s ? JSON.stringify(s, null, 2) : s;
      E.info(`Logged custom attribute: ${i} with value: ${t}`);
    }
    return h;
  }
  setLastKnownLocation(t, i, s, e, h, n) {
    const o = { latitude: i, longitude: s };
    null != e && (o.altitude = e),
      null != h && (o.ll_accuracy = h),
      null != n && (o.alt_accuracy = n);
    const r = v.lt(f.yd, o, t || void 0);
    return (
      r &&
        E.info(`Set user last known location as ${JSON.stringify(o, null, 2)}`),
      r
    );
  }
  $r(t, i) {
    const s = this.C.el();
    return new De(this.vs.getUserId(), f.jd, t, s, { cid: i });
  }
  Sd(t, i) {
    return new et(t, i);
  }
  Ya() {
    const t = et.Us.Rs;
    this.Sd(t, E).setItem(t.Fs.Ze, 1, {
      baseUrl: this.baseUrl,
      data: { api_key: this.tu, device_id: this.eu.ve().id },
      userId: this.vs.getUserId(),
      sdkAuthEnabled: this.hl.wh(),
    });
  }
  Fr(t) {
    for (const i of t)
      if (i.api_key === this.tu) this.j.kl(i.events, i.attributes);
      else {
        const t = et.Us.Rs;
        new et(t, E).setItem(t.Fs.zr, P.se(), i);
      }
  }
  Na(t, i, s) {
    if (this.h.qu(t))
      return (
        E.info(`Custom Attribute "${t}" is blocklisted, ignoring.`), new H()
      );
    let e, h;
    return (
      null === i && null === s
        ? ((e = f.Ad), (h = { key: t }))
        : ((e = f.Dd), (h = { key: t, latitude: i, longitude: s })),
      v.lt(e, h)
    );
  }
  Ra(t, i) {
    const s = { group_id: t, status: i };
    return v.lt(f.$d, s);
  }
}
